import { render } from "./SecurityCaptchaView.vue?vue&type=template&id=a1fc416e&scoped=true"
import script from "./SecurityCaptchaView.vue?vue&type=script&lang=js"
export * from "./SecurityCaptchaView.vue?vue&type=script&lang=js"

import "./SecurityCaptchaView.vue?vue&type=style&index=0&id=a1fc416e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fc416e"]])

export default __exports__